import axios from 'axios';

// API pública de feriados (sin autenticación). Soporta CL y PE, entre otros.
const HOLIDAYS_API_URL = process.env.VUE_APP_HOLIDAYS_API_URL || 'https://date.nager.at/api/v3';

// Caché en memoria por país+año para evitar llamadas repetidas.
const cache = {};

export default class HolidaysServices {
  /**
   * Obtiene los feriados de un país y año como un arreglo de strings 'YYYY-MM-DD'.
   * @param {number} year
   * @param {string} countryIso ISO-2 del país (ej. 'CL', 'PE')
   */
  static async getHolidays(year, countryIso = 'CL') {
    const country = (countryIso || 'CL').toUpperCase();
    const key = `${country}-${year}`;
    if (cache[key]) {
      return { status: 'ok', data: cache[key] };
    }
    try {
      const url = `${HOLIDAYS_API_URL}/PublicHolidays/${year}/${country}`;
      const response = await axios.get(url);
      const dates = Array.isArray(response.data)
        ? response.data.map((h) => h.date).filter(Boolean)
        : [];
      cache[key] = dates;
      return { status: 'ok', data: dates };
    } catch (err) {
      return { status: 'error' };
    }
  }
}
